<template>
  <div class='codemirror e-tab-wrap h-mmlTabs-content'>
    <div class='h-mml-scnrbox'>
      <codemirror
        v-model='mmlCode'
        :options='cmOptions'
        ref='myCm'>
      </codemirror>
    </div>
    <div class='h-input-btns'>
      <ejs-button class='e-btn e-control e-primary' :disabled='this.mmlCmdButtonDisabled' v-on:click.native='getCmdAndExec'>{{count>0?$t('MML.executing'):$t('MML.execute')}}</ejs-button>
      <ejs-button class='e-btn e-control e-primary' :disabled='this.mmlCmdButtonDisabled' v-on:click.native='showHistory'>{{$t('MML.history')}}</ejs-button>
    </div>
    <CustomDialog ref='mmlHistoryDialog' :element='historyDialog.element' :styles='historyDialog.styles'>
      <template v-slot:dialog-content>
        <command-history ref='mmlHistory' :history-commands='historyCommands'></command-history>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { CodeMirror } from 'vue-codemirror';
import { createNamespacedHelpers } from 'vuex';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/neo.css';
import 'codemirror/addon/selection/active-line.js';
import mmlMode from './CodeMirror';
import CustomDialog from '@/components/common/CustomDialog';
import CommandHistory from './CommandHistory';
import bus from '../bus.js';

CodeMirror.defineMode('mmlmode', mmlMode);
const { mapGetters } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'command-editor',
  components: {
    CustomDialog,
    CommandHistory
  },
  data() {
    return {
      mmlCode: '',
      cmOptions: {
        tabSize: 4,
        lineNumbers: true,
        lineWrapping: true,
        styleActiveLine: true,
        scrollbarStyle: 'null',
        theme: 'neo',
        mode: {
          name: 'mmlmode'
        },
      },
      count: 0,
      historyCommands: [],
      historyDialog: {
        element:{
          title: this.$t('MML.history'),
          target: '#app',
          isClose: true,
          refName: 'realHistoryDialog',
          buttonGroup: [
            {
              click: this.hideHistory,
              buttonModel: { content: this.$t('MML.cancel') }
            },
            {
              click: this.addHistory2Cmd,
              buttonModel: {
                content: this.$t('MML.confirm'),
                isPrimary: true
              }
            }
          ]
        },
        styles: {
          width: '600px',
          height: '650px',
          visible: false,
          model: true
        }
      }
    };
  },
  created() {
    bus.$on('deleteEditorLine', () => {
      this.deleteLineAfterExec();
    });
  },
  mounted() {
    this.codemirror.setCursor({ line: 0 });
  },
  computed: {
    ...mapGetters(['mmlCmdButtonDisabled']),
    codemirror() {
      return this.$refs.myCm.codemirror;
    }
  },
  methods: {
    refreshCmd() {
      console.log('---cmd refresh---');
      this.codemirror.setSize('100%', '100%');
      this.codemirror.refresh();
    },
    addMML(mml) {
      const position = this.codemirror.getCursor();
      if (position.line === 0 && position.ch === 0) {
        this.codemirror.replaceRange(mml, position, position);
      } else {
        this.codemirror.replaceRange(`\n${mml}`, position, position);
      }
    },
    getCmdAndExec() {
      if (this.count > 0) {
        // 再次点击执行时停止操作
        this.count = 0;
        this.$emit('ready-to-exec', [], true);
        return;
      }
      const cmdList = this.codemirror.getMode().getCmdLst(this.codemirror);
      this.count = cmdList.length;
      this.$emit('ready-to-exec', cmdList, true);
    },
    showHistory() {
      // 给historyCommands赋值 从localStorage中取值
      this.historyCommands = JSON.parse(localStorage.getItem('mml_history_cmds')) || [];
      this.$refs.mmlHistoryDialog.show();
    },
    addHistory2Cmd() {
      const mmlRecords = this.$refs.mmlHistory.getCheckedRecords();
      mmlRecords.forEach(record => {
        const { cmd } = record;
        const position = this.codemirror.getCursor();
        if (position.line === 0 && position.ch === 0) {
          this.codemirror.replaceRange(cmd, position, position);
        } else {
          this.codemirror.replaceRange(`\n${cmd}`, position, position);
        }
      });
      this.$refs.mmlHistoryDialog.clear();
      this.$refs.mmlHistoryDialog.close();
    },
    hideHistory() {
      this.$refs.mmlHistoryDialog.clear();
      this.$refs.mmlHistoryDialog.close();
    },
    // 当执行出现异常或者上一次执行结果返回时调用此函数
    deleteLineAfterExec() {
      let i = 0;
      // 取rightPanel中的stopFlag标识
      const stopFlag = this.$parent.$parent.stopFlag;
      console.log('stopflag:',stopFlag);
      /* eslint-disable-next-line */
      while (true) {
        const cmd = this.codemirror.getLine(i);
        if (cmd && (cmd.indexOf('//') >= 0 || cmd === '')) {
          i++;
        } else {
          break;
        }
      }
      for (let j = 0; j < i + 1; j++) {
        this.codemirror.replaceRange('', { line: stopFlag, ch: 0 }, { line: stopFlag + 1, ch: 0 });
      }
      const cmdList = this.codemirror.getMode().getCmdLst(this.codemirror);
      if (cmdList.length <= 0) {
        this.count = 0;
      }
    }
  },
  beforeDestroy() {
    bus.$off('deleteEditorLine');
  }
};
</script>

<style>
</style>
